import { useCallback, useId } from 'react'

const PARAM_NAME = 'validate-oab-modal'
let lockId: string | null = null

function getUrlParam() {
  return new URLSearchParams(window.location.search).get(PARAM_NAME)
}

function getUrlParamByLockId(compId: string): string | null {
  // uses identifierPrefix to share the state across the same modal instance
  const id = compId.split(':').find((part) => !!part) ?? ''
  if (lockId === id || lockId === null) {
    lockId = id
    return getUrlParam()
  }
  return null
}

export function useOabTransferringEmailJwt() {
  const compId = useId()
  const emailJwt = typeof window === 'undefined' ? null : getUrlParamByLockId(compId)

  const removeUrlParam = useCallback(() => {
    const url = new URL(window.location.href)
    url.searchParams.delete(PARAM_NAME)
    window.history.replaceState(window.history.state, '', url)
  }, [])

  return { emailJwt, removeUrlParam }
}
